module.exports = __webpack_public_path__ + "assets/models/Loading-9860a7a83aee5ece11966d09b58df6cc.glb";